module.exports = __webpack_public_path__ + "static/media/swat_img.181a99ba.jpg";